<template lang="pug">
  div(class="")
    h2(class="title-32px fw-700") {{ $t('Plan send') }}
    div(class="form-document-send-later")
      e-input-datetime(
        v-model="selectedDate"
        :menu-left-offset="0"
        :menu-bottom-offset="0"
        show-prepended-icon
        :min="minDate"
        filled
        hide-details
        custom-format="DD.MM.YYYY"
      )
      div(class="form-document-send-later__divider")
        div(class="text-14px dark fw-300") {{ $t('at') }}
      e-input-time(
        v-model="selectedTime"
        :scheduled-at="document.scheduledAt"
        ref="timeInput"
      )
    v-btn(
      class="main-button w-100"
      :loading="loading"
      :disabled="disabledButton"
      @click="sendLater"
    )
      span(class="pr-1") {{ $t('Send') }}
      span(class="pr-1") {{ formattedDate }}
      span(
        v-if="selectedTime"
        class="pr-1"
      ) {{ $t('at') }}
      span(class="pr-1") {{ selectedTime }}
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import EInputDatetime from '~/components/elements/inputs/e-input-datetime'
import EInputTime from '~/components/elements/inputs/e-input-time'
import documentActions from '~/modules/documents/mixins/documentActions'
import { formats } from '~/const/global'
import 'moment/locale/uk'
import informationSnackbar from '~/modules/snackbar/mixins/informationSnackbar'

export default {
  name: 'FormDocumentDelayedSend',
  components: {
    EInputTime,
    EInputDatetime
  },
  mixins: [documentActions, informationSnackbar],
  props: {
    document: {
      type: Object,
      default: null
    },
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      selectedDate: new Date(),
      selectedTime: null
    }
  },
  computed: {
    ...mapGetters('templatefields', {
      filledFields: 'filledFields'
    }),
    minDate() {
      return () => this.$moment().format(formats.dateISO8601)
    },
    formattedDate() {
      if (!this.selectedDate) return null
      return this.$moment(this.selectedDate, formats.date)
        .locale('uk')
        .format(formats.dayMonthFulNameYear)
    },
    isEdit() {
      return !!this._.get(this.document, 'scheduledAt', false)
    },
    disabledButton() {
      const pickerDate = this.selectedDate + ' ' + this.selectedTime
      return this.isEdit && this.$moment(this.document.scheduledAt).isSame(this.$moment(pickerDate))
    }
  },
  created() {
    if (this.isEdit) {
      this.setScheduledDatetime()
    } else {
      this.setTime()
    }
  },
  methods: {
    setScheduledDatetime() {
      const formattedDate = this.$moment(this.document.scheduledAt)
        .local()
        .format(formats.dateTimeSec)
      const [date, time] = formattedDate.split(' ')
      this.selectedDate = date
      this.selectedTime = time
    },
    async sendLater() {
      const { valid } = await this.$refs.timeInput.validate()
      if (!valid) {
        return
      }
      try {
        this.loading = true
        if (this.filledFields.length) {
          await this.fillDynamicFields(this.document)
        }
        let timeWithMs
        if (this.isEdit) {
          timeWithMs = this.selectedTime
        } else {
          timeWithMs = `${this.selectedTime}:00`
        }
        const isSent = await this.sendDocument(this.document, {
          scheduledAt: `${this.selectedDate} ${timeWithMs}`
        })
        if (isSent) {
          this.closeModal()
          await this.informationSnackbar.open({
            icon: 'clock-play-white',
            text: this.$t('Your document will be send at {date}', {
              date: this.formattedDate + ' ' + this.selectedTime
            })
          })
        }
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    },
    setTime() {
      const userTime = moment.tz(moment.tz.guess())
      this.selectedTime = userTime.clone().add(1, 'hour').format('HH:mm')
    }
  }
}
</script>

<style scoped lang="scss">
.form-document-send-later {
  display: grid;
  grid-template-columns: 1fr 20px 1fr;
  padding: 32px 0;
  gap: 16px;

  &__divider {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
